import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';
import { history } from '@umijs/max';

// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (url: string, options: RequestOptions) => {
      const token = localStorage.getItem('token') || '';
      const { data, method, params } = options;
      // 兼容antd默认数据格式
      const query = { ...data, ...params }
      // 针对列表接口参数处理
      if (query?.current) {
        query.pageNum = query.current
        delete query.current
      }
      const requestData = { params: {}, data: {} }
      if (method?.toLowerCase() === 'get') {
        requestData.params = query
      } else {
        requestData.data = query
      }
      return {
        url,
        options: { ...options, ...requestData, interceptors: true, headers: { ...token && { 'satoken': token.replaceAll('"', '') } } },
      };
    }
  ],

  // 响应拦截器
  responseInterceptors: [
    [(response: any) => {
      if (response.config.responseType === 'blob' || response.data instanceof Blob) {
        return response;
      }
      const { data } = response;
      // 兼容数据结构
      if (data?.code === 2000) {
        const resultData = data?.data
        // 兼容列表数据结构
        if (data?.data?.records) {
          resultData.data = data?.data?.records
        }
        return { ...response, data: resultData, success: true, };
      }
      if ([4001].includes(data?.code)) {
        localStorage.setItem('token', '')
        history.replace('/user/login');
        return Promise.reject('请登录')
      }
      // 验证码错误处理
      if ([4013].includes(data?.code)) {
        return Promise.reject(data.code);
      }
      message.error(data?.msg || '请求失败！');
      return Promise.reject(data?.msg || '请求失败！')
    }, (error: any) => {
      message.error(error?.data?.msg || '网络请求失败！');
      return Promise.reject('网络请求失败')
    }],
  ],
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const requestConfig: RequestConfig = {
  timeout: 60000,
  baseURL: process.env.GLOBAL_API_URL,
  ...errorConfig,
};
